import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import DividerComponent from 'components/Divider/Divider';
import RouterStepper from 'components/Stepper/RouterStepper';
import { LargeHeader } from 'components/Text';
import useUnregisterVehicle from 'hooks/vehicles/unregister/useUnregisterVehicle';
import { HOME } from 'routes/home/paths';
import { TAG_DETAILS } from 'routes/overview/paths';
export default function UnregisterVehicleLayout({
  onForwardButtonClick,
  hasForwardButtonDisabled,
  altForwardButtonText,
  children,
  isForwardButtonLoading,
  isFinalStep
}) {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    tagNumber
  } = useParams();
  const {
    reset
  } = useUnregisterVehicle();
  const getBackPath = () => {
    reset();
    return tagNumber ? push(TAG_DETAILS(tagNumber)) : push(HOME);
  };
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(LargeHeader, null, t('unregister_vehicle.remove_vehicle')), /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, children), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(RouterStepper, {
    onBackButtonClick: getBackPath,
    onForwardButtonClick: onForwardButtonClick,
    hasForwardButtonDisabled: hasForwardButtonDisabled,
    altForwardButtonText: altForwardButtonText,
    isForwardButtonLoading: isForwardButtonLoading,
    isFinalStep: isFinalStep
  }));
}